const api = {
    baseApi: "https://prop-vista-backend.vercel.app/"
}

export default api;
